import React, { useRef, useEffect } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";

function BlackHolev2() {
  const blackHoleRef = useRef();
  const { scene, gl } = useThree();

  const cubeRenderTarget = useRef(
    new THREE.WebGLCubeRenderTarget(256, {
      format: THREE.RGBAFormat,
      generateMipmaps: true,
      minFilter: THREE.LinearMipmapLinearFilter,
    })
  );

  const cubeCamera = useRef(new THREE.CubeCamera(1, 500, cubeRenderTarget.current));

  useEffect(() => {
    cubeRenderTarget.current.texture.colorSpace = THREE.SRGBColorSpace;
  }, []);

  let frameCount = 0; // ✅ Počítadlo snímků

  useFrame(() => {
    frameCount++;

    if (frameCount % 3 === 0) { // ✅ Aktualizace pouze každých 5 snímků (nižší zátěž)
      if (blackHoleRef.current) {
        blackHoleRef.current.visible = false;
        cubeCamera.current.update(gl, scene);
        blackHoleRef.current.visible = true;
      }
    }
  });

  return (
    <group>
      <cubeCamera ref={cubeCamera} args={[1, 500, cubeRenderTarget.current]} />
      <mesh ref={blackHoleRef} position={[0, 0, 0]}>
        <sphereGeometry args={[6, 64, 64]} />
        <meshPhysicalMaterial
          envMap={cubeRenderTarget.current.texture}
          metalness={1}
          roughness={0}
          clearcoat={1}
          clearcoatRoughness={0.05}
          reflectivity={1}
          transmission={0.1}
          ior={2.5}
          color="black"
        />
      </mesh>
    </group>
  );
}

export default BlackHolev2;